import { render, staticRenderFns } from "./info.component.vue?vue&type=template&id=4ed2794d&scoped=true"
import script from "./info.component.vue?vue&type=script&lang=ts"
export * from "./info.component.vue?vue&type=script&lang=ts"
import style0 from "./info.component.vue?vue&type=style&index=0&id=4ed2794d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed2794d",
  null
  
)

export default component.exports